import { action } from 'satcheljs';
import { DateRange } from 'mini-datetime-utils';
import { OwaDate } from 'owa-datetime';

const dateRangeChanged = action(
    'dateRangeChanged',
    (newDateRange: DateRange, anchorDate?: OwaDate) => ({
        newDateRange,
        anchorDate,
    })
);

export default dateRangeChanged;
